import React from 'react';
import {Link} from 'react-router-dom';
import MetaTags from "../components/MetaTags";
const Solnishko: React.FC = () => {

    MetaTags(
        "Кулон «Солнышко»&nbsp;— схема плетения",
        "Урок по плетению кулона «Солнышко» на основе объемной цепочки «квадратный столбик». Кулон изготовлен из мелкого бисера. Можно сделать из него брелок."
    )

    return <>
        <h2>Кулон «Солнышко»&nbsp;— схема плетения</h2>

        <p>Для плетения понадобится бисер одного размера: ярко желтый непрозрачный и белый прозрачный, а также леска
            толщиной 0,2мм.</p>
        <p>«Солнышко» изготовлено на основе <Link to="/kvadrat-stolbik">квадратного столбика</Link>.</p>

        <p>Сначала сплетем квадратную цепочку из мелкого желтого бисера и соединим ее в кольцо.
            Длина кольца 14 кубиков (13 плюс 1 на соединение). Затем сплетем большое колечко из белого и желтого бисера.
            Один кубик желтый и 5 белых. Должно получиться 7 желтых кубиков и 7 белых участков. Соединяем в кольцо.</p>
        <p>Теперь делаем лучики. Один свободный конец лески выводим на внешнюю сторону маленького колечка и приплетаем 2
            кубика. Второй конец протягиваем по кольцу через один кубик и плетем следующий лучик&nbsp;— еще 2
            кубика.</p>

        <p>Маленький круг состоит из 14 кубиков для того, чтобы получилось 7 лучиков у «Солнышка». А большой круг
            содержит 42 кубика 7 из которых желтые.</p>
        <p>Теперь берем большое колечко и плетем 2 лучика, только уже вовнутрь кольца. (Фото 1)</p>

        <img src="/image/Schema/sun_foto1.jpg" width="480" height="270"
             className="schema img-thumbnail col-centered img-responsive" alt=""/>
        <p>Вообще каждый лучик можно плести отдельно, но проще использовать уже имеющиеся концы лесок.</p>
        <p>Соединяем лучик маленького кольца с желтым кубиком большого. (Фото 2)</p>
        <p>Остальные 3 лучика доделываем также. Получилось 4 лучика. (Фото 3)</p>
        <img src="/image/Schema/sun_foto2.jpg" width="275" height="248"
             className="schema img-thumbnail col-centered img-responsive" alt=""/>
        <img src="/image/Schema/sun_foto3.jpg" width="275" height="248"
             className="schema img-thumbnail col-centered img-responsive" alt=""/>
        <p>Протягиваем леску по маленькому колечку и начинаем плести новый лучик. (Фото 4)</p>
        <img src="/image/Schema/sun_foto4.jpg" width="300" height="270"
             className="schema img-thumbnail col-centered img-responsive" alt=""/>
        <p>Оставшиеся лучики плетем точно также.</p>

        <p>Закрепляем концы лески. Для этого завязываем узелок, а конец лески пропускаем через несколько
            ближайших бисеринок. На узелок можно капнуть немного клея ПВА для закрепления.</p>
        <p>«Солнышко» готово. (Фото 5)</p>

        <img src="/image/Schema/sun_foto5.jpg" width="300" height="270"
             className="schema img-thumbnail col-centered img-responsive" alt=""/>
        <p>Я прикрепила к украшению бисерную нить так, чтобы ее длины хватило для одевания через
            голову&nbsp;— получился кулон. (Фото 6)</p>
        <img src="/image/Schema/sun_foto6.jpg" width="550" height="468"
             className="schema img-thumbnail col-centered img-responsive" alt="Кулон Солнышко"/>
        <p>Можно сделать нить покороче если использовать застежку. Для нити можно использовать
            более толстую леску и сложить ее вдвое, чтобы она была крепче. Еще можно прикрепить
            к «Солнышку» петельку и сделать брелок или брошку.</p>
    </>;
};

export default Solnishko;

